import { Button } from '@/components/ui/button';
import { FC } from 'react';
import { TrusteesUtils } from '@/features/trustees/utils/trusteesUtils';
import Download_04_Icon from '@/components/icons/Download_04_Icon';
import { cn } from '@/lib/utils';

type Props = {
	id: string;
	type: 'purchase' | 'management';
	isMobile?: boolean;
};

const AgreementsListElement: FC<Props> = ({ id, type, isMobile }) => {
	const {
		label,
		icon: IconComponent,
		iconColor,
		iconBgColor,
	} = TrusteesUtils.getAgreementsElementConfig(type);

	return (
		<div
			className={cn(
				'p-6 flex items-center gap-4 border border-popover-100 rounded-2.5xl bg-popover-10',
				isMobile && 'p-4',
			)}>
			<div
				className={`size-8 flex items-center justify-center rounded-semi-xl ${iconBgColor}`}>
				<IconComponent className={iconColor} />
			</div>
			<div className='flex flex-col'>
				<span
					className={cn(
						'text-base font-medium',
						isMobile && 'text-sm',
					)}>
					{id}
				</span>
				<span className='text-sm text-popover-600'>{label}</span>
			</div>
			<Button
				variant='outline'
				size='icon'
				className='size-8 ml-auto'>
				<Download_04_Icon />
			</Button>
		</div>
	);
};

export default AgreementsListElement;
